import React, { } from "react";
import './scoutbox.style.scss';
import { useDataLayer } from "../../../../Contexts/DataLayer.context";
import checkIcon from '../../../../assets/icons/checkbox-check.svg';
import checkIconOff from '../../../../assets/icons/checkbox.svg';

const ScoutBox = ({ displayName, checkBoxArray, onClick }) => {
  const { scoutArray = [] } = useDataLayer();

  return (
    <div className="scoutbox-scout-list d-flex flex-column">
      <div className="w-100 text-center mb-2">
        <span className="text-danger fw-bold">{displayName}</span>
      </div>

      {scoutArray.length > 0 ? (
        <div>
          {scoutArray.map((scout, index) => (
            <div
              className="scoutLine"
              key={index}
              onClick={() => onClick(scout.userId)}
            >
              <div className="checkBox">
                <img
                  src={checkBoxArray.includes(scout.userId) ? checkIcon : checkIconOff}
                  alt="Checkbox Icon"
                  style={{ width: '24px', height: '24px' }}
                />
              </div>
              <div className="scoutName">{scout.displayName || scout}</div>
            </div>
          ))}
        </div>
      ) : (
        <p>No scouts available.</p>
      )}
    </div>
  );
};

export default ScoutBox;
